import { useEffect } from 'react';
import { logEvent } from 'utils/eventTracking';

interface IUseUnloadProps {
  event: string;
  properties?: {} | undefined;
}
const useUnload = (props: IUseUnloadProps) => {
  const unload = () => {
    props?.event && logEvent(props?.event, props?.properties);
  };

  useEffect(() => {
    window?.addEventListener('beforeunload', unload);

    return () => {
      window?.removeEventListener('beforeunload', unload);
    };
  }, []);
};

export default useUnload;
